import { GetUniqueOrigin, GetUniqueVessel, GetUniqueVoyage, GetUniqueDestination, GetUniqueActualVessel, GetUniqueVoyageRemark, } from '../OutBoundPdf/LLContent'

export function LLExcel(XLSX, data) {
    // console.log('data', data)
    var origin = GetUniqueOrigin(data.voyageBranches)
    var destination = GetUniqueDestination(data.voyageBranches)
    var vessel = GetUniqueVessel(data.voyageBranches)
    var voyage = GetUniqueVoyage(data.voyageBranches)
    var actualVessel = GetUniqueActualVessel(data.voyageBranches)
    var voyageRemark = GetUniqueVoyageRemark(data.voyageBranches)
    var wb = XLSX.utils.book_new();

    // Header
    var ws = XLSX.utils.json_to_sheet([{}], { header: [], skipHeader: true });

    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "OCEAN TRANSPORT GROUP OF COMPANIES INC.", }], { header: [], skipHeader: true, origin: -1 });
    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "LOAD LIST", }], { header: [], skipHeader: true, origin: -1 });
    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: origin[0] + ' – ' + destination.join(' – '), }], { header: [], skipHeader: true, origin: -1 });
    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: 'Voyage Sequence: ' + voyage[0], }], { header: [], skipHeader: true, origin: -1 });
    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: 'Planned Vessel/Voyage Ref: ' + vessel[0] + ' ' + voyageRemark[0], }], { header: [], skipHeader: true, origin: -1 });
    if (actualVessel[0] !== null) {
        XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: 'Actual Vessel/Voyage Ref: ' + actualVessel[0] + ' ' + voyageRemark[0], }], { header: [], skipHeader: true, origin: -1 });
    }
    XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "" }], { header: [], skipHeader: true, origin: -1 });

    XLSX.utils.sheet_add_json(ws, [
        {
            A: "SHIPPER", B: "CONSIGNEE", C: "SEAL NO.", D: "COMMODITY",
            E: "CONTAINER #", F: "CARGO TYPE", G: "WEIGHT(TONS)", H: "STATUS", I: "REMARKS"
        }
    ], {
            header: [], skipHeader: true, origin: -1
        });

    data.wayBIll.forEach(element => {
        XLSX.utils.sheet_add_json(ws, [
            {
                A: element.shipper, B: element.consignee, C: element.sealNum, D: element.goods,
                E: element.vanNumber, F: element.cargoType, G: element.cargoWeight,
                H: element.releaseType, I: element.releaseTag
            }
        ], {
                header: [], skipHeader: true, origin: -1
            });

    });

    if(data.revision && data.revision.length > 0) {
        XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "" }], { header: [], skipHeader: true, origin: -1 });

        // XLSX.utils.sheet_add_json(ws, [{ A: "REVISION", }], { header: [], skipHeader: true, origin: -1 });
    
        // XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "" }], { header: [], skipHeader: true, origin: -1 });
    
        // XLSX.utils.sheet_add_json(ws, [{ A: "ADDED", }], { header: [], skipHeader: true, origin: -1 });
    
        // XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "" }], { header: [], skipHeader: true, origin: -1 });
    
        XLSX.utils.sheet_add_json(ws, [{ A: "ADDED BOOKING REF / VAN #", }], { header: [], skipHeader: true, origin: -1 });
    
        data.revision.forEach(r => {
            // eslint-disable-next-line
            r.wayBill.filter(w => w.status === "added").map(wb => {
                XLSX.utils.sheet_add_json(ws, [{ A: wb.containerVanNum, }], { header: [], skipHeader: true, origin: -1 });
            });
        })
    
        XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "" }], { header: [], skipHeader: true, origin: -1 });
    
        // XLSX.utils.sheet_add_json(ws, [{ A: "REMOVED", }], { header: [], skipHeader: true, origin: -1 });
    
        // XLSX.utils.sheet_add_json(ws, [{ A: "", B: "", C: "", D: "", E: "", F: "", G: "" }], { header: [], skipHeader: true, origin: -1 });
    
        XLSX.utils.sheet_add_json(ws, [{ A: "REMOVED BOOKING REF / VAN #", }], { header: [], skipHeader: true, origin: -1 });
    
        data.revision.forEach(r => {
            // eslint-disable-next-line
            r.wayBill.filter(w => w.status === "removed").map(wb => {
                XLSX.utils.sheet_add_json(ws, [{ A: wb.containerVanNum, }], { header: [], skipHeader: true, origin: -1 });
            });
        })
    }

    var wscols = [
        { wch: 25 }, // Shipper
        { wch: 25 }, // Consignee
        { wch: 15 }, // Seal Number
        { wch: 25 }, // Goods
        { wch: 12 }, // Container
        { wch: 10 }, // Cargo Type
        { wch: 12 }, // Weight
        { wch: 15 }, // Status
        { wch: 25 }, // Remarks
    ];

    ws['!cols'] = wscols;

    XLSX.utils.book_append_sheet(wb, ws, "Load List");

    XLSX.writeFile(wb, "Load_List.xlsx")
}